// extracted by mini-css-extract-plugin
export default {"description":"style_description__o-XeJ","fade-in":"style_fade-in__8s7iz","top":"style_top__stqlU","image":"style_image__gU+D+"};